<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Well Barrier Status Historical Records
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer style="padding: 5px;">

    <div class="text-center text-3xl py-6">
        <b>{{ data.wellLongName }}</b>
    </div>

    <table class="table table-zebra text-center table-border-bottom">
        <thead class="header">
            <tr class="text-center tableHeader-bg-color">
                <td> No </td>
                <td> Crown Valve </td>
                <td> Wing Valve </td>
                <td> Kill Wing Valve </td>
                <td> Surface Safety Valves </td>
                <td> Lower Safety Valves </td>
                <td> Conductor Casing Valves </td>
                <td> Surface Casing Valves </td>
                <td> Intermediate Casing Valves </td>
                <td> Production Casing Valves </td>
                <td> Conductor Casing </td>
                <td> Surface Casing </td>
                <td> Intermediate Casing </td>

                <td> Production Casing (Above Packec) </td>
                <td> Production Casing (Below Packec) </td>
                <td> Casing Hanger </td>
                <td> Tubing Hanger </td>
                <td> Cement (Conductor Casing) </td>
                <td> Cement (Surface Casing) </td>
                <td> Cement (Intermediate Casing) </td>
                <td> Cement (Production Casing) </td>

                <td> Production Tubing (Above DHSV)</td>
                <td> Production Tubing (Below DHSV)</td>

                <td> Downhole Safety Valve </td>
                <td> DHSV Control Line </td>
                <td> Safety Valve Landing Nipple </td>
                <td> SVLN Control Line </td>
                <td> Gas Lift Mandrel </td>
                <td> Sliding Side Door </td>
                <td> Production Pakcer </td>
                <td> Tubing Plug </td>
                <td> BPV / TWCV </td>
                <td> VR Plug </td>
                <td> Caprock </td>
                <td> Void Area </td>
                <td> IN-SITU Formation </td>
                <td> Action </td>

            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="wellBarrierHistoricalRecords.length > 0 ; else noData">
                <tr *ngFor="let wellBarrierHistoricalRecord of wellBarrierHistoricalRecords;  let i = index">
                    <td> {{ i + 1 }}</td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.crownValve)">{{
                            wellBarrierHistoricalRecord.crownValve ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.wingValve)">
                            {{ wellBarrierHistoricalRecord.wingValve ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.killWingValve)">
                            {{ wellBarrierHistoricalRecord.killWingValve ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.surfaceSafetyValve)">
                            {{ wellBarrierHistoricalRecord.surfaceSafetyValve ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.lowerMasterValve)">
                            {{ wellBarrierHistoricalRecord.lowerMasterValve ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.conductorCasingValves)">
                            {{ wellBarrierHistoricalRecord.conductorCasingValves ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.surfaceCasingValves)">
                            {{ wellBarrierHistoricalRecord.surfaceCasingValves ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.intermediateCasingValves)">
                            {{ wellBarrierHistoricalRecord.intermediateCasingValves ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.productionCasingValves)">
                            {{ wellBarrierHistoricalRecord.productionCasingValves ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.conductorCasing)">
                            {{ wellBarrierHistoricalRecord.conductorCasing ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.surfaceCasing)">
                            {{ wellBarrierHistoricalRecord.surfaceCasing ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.intermediateCasing)">
                            {{ wellBarrierHistoricalRecord.intermediateCasing ?? '-' }}
                        </div>
                    </td>

                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.productionCasingAbovePaker)">
                            {{ wellBarrierHistoricalRecord.productionCasingAbovePaker ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.productionCasingBelowPaker)">
                            {{ wellBarrierHistoricalRecord.productionCasingBelowPaker ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.casingHanger)">
                            {{ wellBarrierHistoricalRecord.casingHanger ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.tubingHanger)">
                            {{ wellBarrierHistoricalRecord.tubingHanger ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.cementConductrorCasing)">
                            {{ wellBarrierHistoricalRecord.cementConductrorCasing ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.cementSurfaceCasing)">
                            {{ wellBarrierHistoricalRecord.cementSurfaceCasing ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.cementIntermediateCasing)">
                            {{ wellBarrierHistoricalRecord.cementIntermediateCasing ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.cementProductionCasing)">
                            {{ wellBarrierHistoricalRecord.cementProductionCasing ?? '-' }}
                        </div>
                    </td>

                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.productionTubingAboveDHSV)">
                            {{ wellBarrierHistoricalRecord.productionTubingAboveDHSV ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.productionTubingBelowDHSV)">
                            {{ wellBarrierHistoricalRecord.productionTubingBelowDHSV ?? '-' }}
                        </div>
                    </td>

                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.downholeSafetyValve)">
                            {{ wellBarrierHistoricalRecord.downholeSafetyValve ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.dhsvControlLine)">
                            {{ wellBarrierHistoricalRecord.dhsvControlLine ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.safetyValveLandingNipple)">
                            {{ wellBarrierHistoricalRecord.safetyValveLandingNipple ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.svlnControlLine)">
                            {{ wellBarrierHistoricalRecord.svlnControlLine ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.gasLiftMandrel)">
                            {{ wellBarrierHistoricalRecord.gasLiftMandrel ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.slidingSideDoor)">
                            {{ wellBarrierHistoricalRecord.slidingSideDoor ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.productionPacker)">
                            {{ wellBarrierHistoricalRecord.productionPacker ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.tubingPlug)">
                            {{ wellBarrierHistoricalRecord.tubingPlug ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.bpvTwcv)">
                            {{ wellBarrierHistoricalRecord.bpvTwcv ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.vrPlug)">
                            {{ wellBarrierHistoricalRecord.vrPlug ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.caprock)">
                            {{ wellBarrierHistoricalRecord.caprock ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.voidArea)">
                            {{ wellBarrierHistoricalRecord.voidArea ?? '-' }}
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="getStatusClass(wellBarrierHistoricalRecord.inSituFormation)">
                            {{ wellBarrierHistoricalRecord.inSituFormation ?? '-' }}
                        </div>
                    </td>

                    <td>
                        <button class="btn btn-remove-bg ">
                            <mat-icon class="text-primary" svgIcon="mat_solid:remove_red_eye" matTooltip="View Details"
                                (click)="openHistoryRecordDetailsModal(wellBarrierHistoricalRecord)"></mat-icon>
                        </button>
                    </td>
                </tr>
            </ng-container>
        </tbody>

        <ng-template #noData>
            <tr>
                <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
                <td style="background-color: #f5f5f5;" colspan="27"></td>
            </tr>
        </ng-template>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>
        Cancel
    </button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>